import { erpAxios } from '.';

const setDatumPotpisaUgovora = async (data) => {
  const res = await erpAxios.post(`/datumPotpisaUgovora/setDatumPotpisaUgovora`, data);
  return res;
};

export default setDatumPotpisaUgovora;
